import { PaymentProviderType } from "@/types/graphql/partner.generated";

/**
 * Подписи провайдеров оплаты. Ключи взяты из настроек оплаты
 * (`paymentSettings.stripeTitle`/`paynetTitle`/`ccbillTitle`): это названия
 * брендов, отдельные переводы для списков и фильтра заводить не нужно.
 *
 * Карта общая для селекта фильтра (`shared/components/Filter/Filter.tsx`) и
 * колонок «Провайдер» в списках покупок, платежей, возвратов и диспутов: раньше
 * таблицы печатали сырой enum (`STRIPE`/`PAYNET`), а фильтр рядом показывал
 * «Stripe»/«Paynet».
 *
 * `Record<PaymentProviderType, string>`, а не `Record<string, string>`: новый
 * провайдер в схеме уронит `tsc`, а не отрендерит пустую подпись.
 */
export const PAYMENT_PROVIDER_LABEL_KEY: Record<PaymentProviderType, string> = {
  [PaymentProviderType.StripeType]: "paymentSettings.stripeTitle",
  [PaymentProviderType.PaynetType]: "paymentSettings.paynetTitle",
  [PaymentProviderType.CcbillType]: "paymentSettings.ccbillTitle",
  [PaymentProviderType.PaypalType]: "paymentSettings.paypalTitle",
};

/**
 * Порядок провайдеров в интерфейсе. Набор провайдеров развёртывания
 * приходит из `instance.paymentProviders` в порядке конфига, а селекты и
 * карточки должны выглядеть одинаково на любом инстансе, поэтому список
 * инстанса не печатается как есть, а пересекается с этим порядком.
 */
export const PAYMENT_PROVIDER_ORDER: PaymentProviderType[] = [
  PaymentProviderType.StripeType,
  PaymentProviderType.PaynetType,
  PaymentProviderType.CcbillType,
  PaymentProviderType.PaypalType,
];
